import React, { useState, useEffect, useContext } from 'react';
import useQueryParams from '../../hooks/useQueryParams';
import AffiliateNavbar from '../Affiliate/Templates/AffiliateNavbar/AffiliateNavbar';
import { SystemMessageContext } from '../../context/SystemMessageContext';
import Affiliate from '../../templates/Affiliate/Affiliate';
import Campaign from '../../templates/Campaign/Campaign';
import Loading from '../../templates/UI/Loading/Loading';
import CampaignNavbar from '../Campaign/CampaignNavBar/CampaignNavBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useCallApi from '../../hooks/useCallApi';
import ReportTable from '../../templates/ReportTable/ReportTable'
import moment from 'moment';
import DirectLinkModal from './DirectLinkModal/DirectLinkModal';
import callAPI from '../../helpers/callAPI';

export default function DirectLinkSettings(){

    document.title = 'Direct Link Settings'    

    const { showSystemMessage } = useContext(SystemMessageContext)
    const { affiliateId, campaignId } = useQueryParams()
    const [ confirmDelete, setConfirmDelete ] = useState(false)
    const [showModal, setShowModal] = useState(false)

    let mode = affiliateId > 0 ? 'affiliate' : campaignId > 0 ? 'campaign' : 'general'

    let url = `affiliates/directAffiliates`

    if (mode === 'affiliate'){
        url += `?affiliate_id=${affiliateId}`
    } else if (mode === 'campaign'){
        url += `?campaign_id=${campaignId}`
    }

    let { data, dataLoaded, refetch } = useCallApi(url, 'GET', {}, [], showSystemMessage)

    const deleteAffiliate = async () => {   
        if (confirmDelete.affiliate_id > 0 && confirmDelete.offer_id > 0) {

            const postBody = {
                affiliate_id: parseInt(confirmDelete.affiliate_id),
                campaign_id: parseInt(confirmDelete.offer_id)
            }

            let result = await callAPI(`affiliates/directAffiliates`, 'DELETE', postBody, false, showSystemMessage)

            if (result.success) {
                showSystemMessage('success', result.message)
                setConfirmDelete(false)
                refetch()
            } else {
                showSystemMessage('error', result.message)
            }
        } else {
            showSystemMessage('error', 'Please select an affiliate and a campaign')
        }
    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Affiliate ID',
                accessor: 'affiliate_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Affiliate',
                accessor: 'affiliate_name',
                Cell: (tableData) => {
                    return <Affiliate aid={tableData.data[tableData.row.index].affiliate_id} name={tableData.data[tableData.row.index].affiliate_name} status={tableData.data[tableData.row.index].aff_status_value} priority={tableData.data[tableData.row.index].aff_priority_value} />
                },
            },
            {
                Header: 'Campaign ID',
                accessor: 'offer_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Campaign',
                accessor: 'offer_name',
                Cell: (tableData) => {
                    return <Campaign oid={tableData.data[tableData.row.index].offer_id} name={tableData.data[tableData.row.index].offer_name} status={tableData.data[tableData.row.index].status_value} />
                },
            },            
            {
                Header: 'API Platform',
                accessor: 'platform_name',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'API Offer ID',
                accessor: 'api_offer_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Added',
                accessor: 'db_date',
                Cell: ({ cell: { value } }) => {
                    return <>{moment(value).utc().format('YYYY-MM-DD')}</>
                },
            },
            {
                Header: '',
                accessor: 'none',
                Cell: (tableData) => {
                    return <>
                        {confirmDelete.affiliate_id === tableData.data[tableData.row.index].affiliate_id && confirmDelete.offer_id === tableData.data[tableData.row.index].offer_id ?
                            <button className="btn btn-danger btn-sm" onClick={()=>{ deleteAffiliate() }}>Confirm</button>
                        :
                            <button className="btn btn-outline-danger btn-sm"
                                onClick={()=>{ setConfirmDelete({
                                    affiliate_id: tableData.data[tableData.row.index].affiliate_id,
                                    offer_id: tableData.data[tableData.row.index].offer_id})
                                    }}>
                                Delete
                            </button>
                    }
                    </>
                },
            },
        ]

        return (
            <React.Fragment>
                <ReportTable data={data.report} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <div>        
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Affiliate Direct Link Settings</h1>
                <div className="ml-5">{affiliateId > 0 ? <AffiliateNavbar affiliateId={affiliateId} showSystemMessage={showSystemMessage} /> : campaignId > 0 ? <CampaignNavbar campaignId={campaignId} showSystemMessage={showSystemMessage} /> : ''}</div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    <div className="card">
                        { dataLoaded && <DirectLinkModal mode={mode} showModal={showModal} setShowModal={setShowModal} refetch={refetch} initCampaign={data.campaign} initAffiliate={data.affiliate} /> }
                        <div className="d-flex justify-content-between p-3 align-items-center">
                            <h1 className="mb-h1-dark mr-2">{dataLoaded ? affiliateId > 0 ? <Affiliate aid={affiliateId} name={data.affiliate.name} priority={data.affiliate.priority.value} status={data.affiliate.status.value} /> : campaignId > 0 ? <Campaign oid={campaignId} name={data.campaign.name} status={data.campaign.status.value} /> : 'All Direct Link Users' : <FontAwesomeIcon icon="spinner" spin />}</h1>
                            <button type="button" className="btn btn-sm btn-warning" onClick={() => { setShowModal(true) }}>
                                Add {mode === 'affiliate' ? 'Campaign' : mode === 'campaign' ? 'Affiliate' : 'Affiliate/Campaign'} Using Direct Link
                            </button>
                        </div>
                        <div className="alert alert-info mx-3">Affiliates on this page do not use MaxBounty affiliate links, and will have their click counts pulled from the appropriate API.</div>
                        {dataLoaded ? data.report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading></Loading>}
                    </div>
                </div>
            </div>            
        </div>
 )   
}